import { CMSModuleBase } from '~/components/organisms/ModularComponent/ModularComponent.types';

import { LogoTileWallRow } from './LogoTileRow/LogoTileRow.types';

export type LogoTileWallProps = CMSModuleBase & {
  rows: LogoTileWallRow[];
};

export const SPEEDS = [1, 1.5, 1.1, 2.3];
